// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { linkListStyles } from "@ces/Overrides/Widgets/Basic/SocialLinks";
import { IconWrapper } from "@insite/mobius/Icon";
import { css } from "styled-components";

linkListStyles.socialLinkListWrapper = {
    css: css`
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        gap: 12px;
    `,
};

linkListStyles.link = {
    css: css`
        gap: 0;

        ${IconWrapper} {
            opacity: 1;
        }
        &.with-appstore-icon {
            ${IconWrapper} {
                height: auto;
                svg {
                    height: auto;
                }
            }
            &:hover {
                opacity: 0.66;
            }
        }
    `,
};
